<template>
  <div>
    <dynamic-inner-table :data="data" />
  </div>
</template>

<script>
import dynamicInnerTable from './dynamic-table'
  export default {
    name: "recursive-table",
    components: {
      dynamicInnerTable
    },
    props: {
      data: {
        type: Object,
        default: ()=> {
          return {}
        }
      }
    },
  }
</script>

<style scoped>

</style>
